// Separate from api/cart.ts and types/cart.ts to avoid a circular dependency —
// api/ imports this schema to call .parse(); types/ re-exports the inferred type.

import { z } from 'zod'

const CalculationResponseTotalsSchema = z.object({
	grandTotal: z.number(),
	// TODO: STO-3138 — subtotal/taxTotal/surchargeTotal needed for checkout cart breakdown rows
	subtotal: z.number().optional(),
	taxTotal: z.number().optional(),
	surchargeTotal: z.number().optional(),
})

export const CalculationResponseSchema = z.object({
	totals: CalculationResponseTotalsSchema,
	// tips is a Record keyed positionally (tipAmount1, tipAmount2, tipAmount3) with cent values,
	// or null when tipSettings was not sent in the request or the location has no tip config.
	// Keys must be sorted alphabetically to get the ordered array — matching Ember:
	// ticket.js:148 — Object.entries(this.get('calculations.tips')).sort().map(e => e[1])
	tips: z.record(z.string(), z.number()).nullable(),
	// Ember: ticket.js:193 — confirms the coupon code was accepted and applied
	activeCouponCode: z.string().optional(),
	// Ember: ticket.js:489 — discount breakdown by source (e.g. loyalty, coupon).
	// name and amount are present on real API responses; optional for older API versions.
	discounts: z
		.array(
			z.object({
				discountRef: z.string(),
				source: z.string(),
				name: z.string().optional(),
				amount: z.number().optional(),
			}),
		)
		.optional(),
	// TODO: STO-XXXX — surcharges[] array needed for per-row breakdown display
	// (with LH-12466 name==='None' workaround). Deferred from STO-3203.
	surcharges: z.array(z.object({ name: z.string(), amount: z.number() })).optional(),
})

// CalculationResponse is inferred from the schema — the schema is the single source of truth.
// types/cart.ts re-exports this type so consumers (ticketSlice.ts) import from types/cart.ts unchanged.
export type CalculationResponse = z.infer<typeof CalculationResponseSchema>
